import { gql } from "@apollo/client";
import { CORE_MISSION_ROLE_TEMPLATE_FIELDS, MISSION_ROLE_TEMPLATE_VETTING_FIELDS } from "graphql/fragments";

const GET_MISSION_ROLE_TEMPLATES = gql`
  ${CORE_MISSION_ROLE_TEMPLATE_FIELDS}
  query GetMissionRoleTemplates {
    missionRoleTemplates {
      nodes {
        ...MissionRoleTemplateFields
      }
    }
  }
`;

const GET_MISSION_ROLE_TEMPLATE = gql`
  ${MISSION_ROLE_TEMPLATE_VETTING_FIELDS}
  query GetMissionRoleTemplate($id: ID!) {
    missionRoleTemplate(id: $id) {
      ...MissionRoleTemplateVettingFields
    }
  }
`;

export { GET_MISSION_ROLE_TEMPLATES, GET_MISSION_ROLE_TEMPLATE };
